/*  Table  */
import { CellContext } from '@tanstack/react-table';

/*  Shared  */
import {
    ApplicationNameLinkCell,
    ApplicationNameLinkCellProps
} from 'application/Shared/Components/ApplicationNameLinkCell';

/*  Objects  */
import { Application } from 'objects/Application';

/* React */
import React from 'react';

export interface ApplicationObjectProps {
    nameLinkTo?: string | object;
    nameHasLink?: boolean;
    rerender?: () => void;
}

export type AppNameLinkCellProps<TData> = CellContext<TData, string> &
    ApplicationNameLinkCellProps &
    ApplicationObjectProps;

export const AppNameLinkCell = <TData,>({
    row,
    ...rest
}: AppNameLinkCellProps<TData>): JSX.Element => {
    const {
        categoryNoTruncate = true,
        nameNoTruncate = true,
        nameClassname = 'bold underline link',
        nameHasLink = true,
        withCategory = true
    } = { ...rest };

    return (
        <Application
            // @ts-expect-error Can't figure this one out
            data={row.original.application || row.original}
            nameHasLink={nameHasLink}
        >
            <ApplicationNameLinkCell
                categoryNoTruncate={categoryNoTruncate}
                nameNoTruncate={nameNoTruncate}
                nameClassname={nameClassname}
                withCategory={withCategory}
                {...rest}
            />
        </Application>
    );
};
